<!-- Body -->
<div class="ui basic segment" [class.loading]="isLoading">
    <app-header title="Benefit Plan" [menuService]="benefitShowMenuService" [back]="true" backRoute="/benefits/plans" />

    <app-table [table]="table" class="table">
        <app-empty-state label="No change requests have been submitted"></app-empty-state>
    </app-table>
</div>
